
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import "../NoteEditPage/NoteEditPage.css"
import { SyntheticEvent, useEffect, useMemo, useRef, useState } from 'react';
import React from 'react'
import DynamicSVG from '../../DynamicSVG/DynamicSVG';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import NoteHandler from '../../../Database/handlers/NoteHandler';
import TopNavBar from '../../TopNavBar/TopNavBar';
import { INote, INoteFolder } from '../../../types/interfaces';
import useLocalStorage from '../../../hooks/useLocalStorage';



interface NoteEditPageProps {

}

export default function NoteEditPage({ }: NoteEditPageProps) {
  const [state, setstate] = useState<{
    folders: INoteFolder[],
    markdown: "Preview" | string,
    viewType: "Editor" | "Preview" | "Split-View" | string,
    pageType:"Create-Note"|"Edit-Note"|string, editNote?:INote
  }>({
    markdown: "",
    viewType: 'Split-View',
    folders: [],
    editNote:undefined,
    pageType:""
  })
  const [project,setproject] = useLocalStorage("project",null)
  const navigator = useNavigate()
  const RouteLocation = useLocation()
  const EditorElement = useRef<HTMLTextAreaElement>(null)
  const noteHandler = new NoteHandler()
 
  function SetMarkdown() {
    const EditorInput = EditorElement.current?.value as string
    setstate({...state, markdown: EditorInput})
  }
  function SetViewType(event:React.MouseEvent<HTMLElement>) {
    console.log(event.currentTarget.id)
    setstate({...state,viewType:event.currentTarget.id})
  }

  function SaveChanges() {
    const TitleInput = document.querySelector("#Title-Input") as HTMLInputElement
    const DescInput = document.querySelector("#Note-Preview-Text") as HTMLInputElement
    const FolderInput = document.querySelector("#Note-Folder") as HTMLInputElement
    
    console.log(TitleInput.value, DescInput.value, FolderInput.value)
    if (TitleInput.value.length > 0 && DescInput.value.length > 0) {
      if (state.pageType == "Edit-Note") {
        noteHandler.EditNote(RouteLocation.state?.id, {
          title: TitleInput.value,
          description: DescInput.value,
          folder: FolderInput.value, content: state.markdown,
          date:new Date(),project:project.ProjectName
        }).then(()=>{navigator("/notes")})
      } else {
        noteHandler.CreateNote(TitleInput.value, DescInput.value,
          FolderInput.value, state.markdown,project.ProjectName).then(() => {
          navigator("/notes")
        })
      }
     
    }
    
    
  }

  useEffect(() => {
    noteHandler.FetchFolders(project.ProjectName).then((folders) => {
      if (!RouteLocation.state) {
      console.log(RouteLocation)
      setstate({ ...state, pageType: "Create-Note",folders:folders })
    } else {
      console.log(RouteLocation)
      setstate({ ...state, pageType: "Edit-Note",markdown:RouteLocation.state?.content, editNote: {
          title: RouteLocation.state?.title,
          folder: RouteLocation.state?.folderData?.title,
          description: RouteLocation.state?.description,
          content: RouteLocation.state?.content,
          date:RouteLocation.state?.date,project:project.ProjectName
      },folders:folders})
    }
    })
    
  }, [])
   

  

  
  return (
    <div className={`Note-Edit-Page-Container Side-Content ${state.viewType}`}>
      <TopNavBar OptionsMenuElements={[
        <button id='Create-Note-Folder-Btn' onClick={SaveChanges}>
          <DynamicSVG SvgName="Plus-Icon" />
          Save Changes
        </button>,
        <button id='Split-View' onClick={SetViewType} >
          Split Screen
        </button>,
        <button id='Editor' onClick={SetViewType} >
          Editor Screen
        </button>,
        <button id='Preview' onClick={SetViewType} >
          Preview Screen
        </button>
      ]}>
        <div className='TopNav-Content'>
          <h1>{state.pageType}</h1>
        </div>
      </TopNavBar>

      <div className='Note-Folder-Input Input-Container'>
        <label>Choose folder</label>
        <select id='Note-Folder'>
          <option value={"None"} disabled >Chose your Note Folder</option>

          <option>{state.editNote?.folder||"All Notes"}</option>
          
          {
            state.folders.map((folder) => {
              if (folder.title == state.editNote?.folder ) {
                return <option key={folder.id}>All Notes</option>
              } else {
                return <option key={folder.id}>{folder.title}</option>
              }
            })
          }
      </select>
      </div>
      
      
      <div className='Title-Container Input-Container'>
        <label className='MDTitleLabel' htmlFor="Title-Input">Title</label>
        <input defaultValue={state.editNote?.title} required id='Title-Input' placeholder='Enter Note Title'  className='Note-Title-Input' type={"text"} />
      </div>
      <div className='Preview-Info-Container Input-Container'>
        <label className='MDDescLabel' htmlFor="Desc-Input">Description</label>
        <textarea defaultValue={state.editNote?.description} required id='Note-Preview-Text' placeholder='Enter a short description about your note' className='Preview-Text'></textarea>
      </div>
      
      {/* <hr /> */}
      <div className='MDEditor-Container Input-Container'>
        <label className='MDEditorLabel' htmlFor="MDEditor">Editor <a target="_blank" href='https://commonmark.org/help/'>Markdown supported</a></label>
        <textarea required placeholder='Start editing...' id='MDEditor' ref={EditorElement} onInput={SetMarkdown} value={state.markdown} className='MDEditor'></textarea>
      </div>
      <div className='MDPreview-Container Input-Container'>
         <label className='MDPreviewLabel'>Preview</label>
         <ReactMarkdown children={state.markdown} className='MDPreview' />
      </div>

    </div>
  )
}